import { connect } from "react-redux";
import { token } from "../../../../modules/auth";
import {
  fetchSalesSummaryItems,
  fetchSnapShotFiguresItems,
  salesSummaryItemsUnload,
  snapShotFiguresItemsUnload,
} from "../../../../redux/actions";
import { getFormValues } from "redux-form";
import { useEffect } from "react";
import React from "react";
import { Cell, GroupHeader, RowHeader, TR } from "../clean-table";
import { detailedEngagements } from "../../../../modules/analytics";
import { createRangeYearToDate } from "../date-utils";
import getDatesArray from "../../../../modules/analytics/get-dates-array";
import { ButtonBrand } from "../../../../Components/Button";

const mapStateToProps = (state, props) => {
  const v = getFormValues("analytics")(state) || {};
  let dates = getDatesArray(
    createRangeYearToDate().start,
    createRangeYearToDate().end
  );
  return {
    token: token(state),
    salesSummaryItems: state.reportingFigures.salesSummaryItems,
    isFetching: state.reportingFigures.isFetching,
    stats: detailedEngagements(
      v.venue_id,
      createRangeYearToDate().start,
      createRangeYearToDate().end
    )(state),
    venues: v.venues,
    startDate:
      typeof props.startDate !== "undefined" ? props.startDate : v.start_date,
    endDate: typeof props.endDate !== "undefined" ? props.endDate : v.end_date,
  };
};

const mapDispatchToProps = {
  fetchSalesSummaryItems,
  salesSummaryItemsUnload,
};

const CorporateViewers = props => {
  const PAGE_SIZE = 20;
  const [showAll, setShowAll] = React.useState(false);
  useEffect(() => {
    props.fetchSalesSummaryItems(
      props.venues,
      props.startDate,
      props.endDate,
      props.type,
      props.token
    );
  }, []);
  const groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  if (
    props.engagementViews.length === 0 && props.engagementInteractions.length === 0 &&
    (!props.salesSummaryItems || props.salesSummaryItems.length === 0)
  ) {
    return <div>No Corporate Engagements</div>;
  }

  let companyGroups = [];
  let companyGroupsI = [];
  if (props.engagementViews.length !== 0) {
    let usersGroups = groupBy(props.engagementViews, "user_type");

    if (usersGroups && usersGroups["Corporate"]) {
      companyGroups = groupBy(usersGroups["Corporate"], "user_company");
    }
  }
  if (props.engagementInteractions.length !== 0) {
    let usersGroupsI = groupBy(props.engagementInteractions, "user_type");

    if (usersGroupsI && usersGroupsI["Corporate"]) {
      companyGroupsI = groupBy(usersGroupsI["Corporate"], "user_company");
    }
  }

  let companiesAdded = [];
  let companiesAddedI = [];
  if (props.salesSummaryItems && props.salesSummaryItems.length > 0) {
    for (const [key, value] of Object.entries(
      groupBy(props.salesSummaryItems, "company")
    )) {
      let engagementCount = 0;
      if (companyGroupsI && companyGroupsI[key]) {
        engagementCount += companyGroupsI[key].length;
      }
      if (key !== "null" && key !== "") {
        companiesAddedI.push({
          key: key,
          count: value.length + engagementCount,
        });
      }
    }
  }
  if (props.engagementViews.length !== 0) {
    for (const [key, value] of Object.entries(companyGroups)) {
      if (
        !companiesAdded.find(company => company.key === key) &&
        key !== "null" &&
        key !== ""
      ) {
        companiesAdded.push({
          key: key,
          count: value.length,
        });
      }
      if (
        !companiesAdded.find(company => company.key === key) &&
        key === "null"
      ) {
        let other = companiesAdded.find(company => company.key === "Other");
        if (other?.length > 0) {
          other.count += value.length;
        } else {
          companiesAdded.push({
            key: "Other",
            count: value.length,
          });
        }
      }

      if (!companiesAdded.find(company => company.key === key) && key === "") {
        let other = companiesAdded.find(company => company.key === "");
        if (other?.length > 0) {
          other.count += value.length;
        } else {
          companiesAdded.push({
            key: "Other",
            count: value.length,
          });
        }
      }
    }
  }

  if (props.engagementInteractions.length !== 0) {
    for (const [key, value] of Object.entries(companyGroupsI)) {
      if (
        !companiesAddedI.find(company => company.key === key) &&
        key !== "null" &&
        key !== ""
      ) {
        companiesAddedI.push({
          key: key,
          count: value.length,
        });
      }
      if (
        !companiesAddedI.find(company => company.key === key) &&
        key === "null"
      ) {
        let other = companiesAddedI.find(company => company.key === "Other");
        if (other?.length > 0) {
          other.count += value.length;
        } else {
          companiesAddedI.push({
            key: "Other",
            count: value.length,
          });
        }
      }

      if (!companiesAddedI.find(company => company.key === key) && key === "") {
        let other = companiesAddedI.find(company => company.key === "");
        if (other?.length > 0) {
          other.count += value.length;
        } else {
          companiesAddedI.push({
            key: "Other",
            count: value.length,
          });
        }
      }
    }
  }

  let mergedAdded = [];
  companiesAdded.map((added) => {{
    mergedAdded.push({
      key: added.key,
      views: added.count,
      interactions: 0
    })
  }});
  companiesAddedI.map((added) => {
    let companyExists = mergedAdded.findIndex((element) => {
      return element.key === added.key
    })
    if(companyExists !== -1){
      mergedAdded[companyExists] = {
        ...mergedAdded[companyExists],
        interactions: added.count
      }
    }else{
      mergedAdded.push({
        key: added.key,
        views: 0,
        interactions: added.count
      })
    }
  })
  return (
    <table>
      <thead>
        <tr>
          <GroupHeader colSpan={3} className="w-1/4">
            Corporate
          </GroupHeader>
          <GroupHeader colSpan={1} className="w-1/4 text-center">
            Views
          </GroupHeader>
          <GroupHeader colSpan={1} className="w-1/4 text-center">
            Interactions
          </GroupHeader>
        </tr>
      </thead>
      <tbody className={"text-xl"}>
        <>
          {mergedAdded
            .sort((a, b) => b.count - a.count)
            .map((company, index) => {

              if (showAll || index < PAGE_SIZE) {
                return (
                  <TR key={company.key}>
                    {window.BASE_URL !== 'https://demo.edgevenues.com' ? <Cell colSpan={2}>{company.key}</Cell> :<Cell colSpan={2}>Company {index}</Cell>}
                    <Cell colSpan={2} className={'text-center'}>{company.views}</Cell>
                    <Cell colSpan={2} className={'text-center'}>{company.interactions}</Cell>
                  </TR>
                );
              }
            })}
        </>
        {companiesAdded.length > PAGE_SIZE ? (
          <div className={"pt-5"}>
            <ButtonBrand onClick={() => setShowAll(!showAll)}>
              {showAll ? "Hide All" : "Show All"}
            </ButtonBrand>
          </div>
        ) : (
          <></>
        )}
      </tbody>
    </table>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CorporateViewers);
